var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.874,
    height: 28.253,
    viewBox: "0 0 28.874 28.253"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_124",
    "data-name": "Groupe 124",
    transform: "translate(-476.362 -462.12) rotate(-30)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(179 645)",
    fill: "#3691d0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(187.933 645)",
    fill: "#3691d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xE9_175",
    "data-name": "Trac\xE9 175",
    d: "M175.63,659c1.4,5.22,5.5,9,10.337,9s8.933-3.78,10.337-9",
    transform: "translate(0 -3.781)",
    fill: "none",
    stroke: "#3691d0",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
};

export default __webpack_public_path__ + "static/media/smiley.7ce9e35f.svg";
export { SvgComponent as ReactComponent };